import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ItnFunded = ({ itnFunded, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="itnFunded" className="planField">
            <GroupApprovers />
            <FormControl required={required.includes("itnFunded")}>
                <FormLabel className="planRadioTitle">
                    {xplanLabels.itnFunded}
                </FormLabel>
                <RadioGroup
                    name="itnFunded"
                    label={xplanLabels.itnFunded}
                    value={itnFunded}
                    onChange={(e) => handleChange("itnFunded", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"itnFunded"} />}
        </div>
    );
};

export default ItnFunded;